import type Distance from "@/model/distance";
import type Pos from "@/model/pos";
import type Place from "@/model/place";
import type Procedure from "@/model/procedure";
import type { RootState } from "@/store/store";
import { useSelector } from "react-redux";
import type Facility from "@/model/facility";
import type { networkConfigItemType } from "@/model/network";
import type Network from "@/model/network";
import type Speciality from "@/model/speciality";
import type { DownloadOptions, SortOptions } from "@/constants";
import type Provider from "@/model/provider";
import useUserInfo from "./use-user-info";

export type ICostEstFilterParams = {
  key: string;
  procedure: Procedure | null;
  targetLocation: Place | null;
  distance: Distance;
  tiers: { name: string }[];
  networks: Network[];
  specialities: Speciality[];
  pos: Pos[];
  facility: Facility | null;
  provider: Provider | null;
  sort: SortOptions;
  limit: DownloadOptions | null;
  transformedNetworkTier: Record<string, networkConfigItemType> | null;
};

const useCostEstFilter = (): ICostEstFilterParams => {
  const {
    key,
    procedure,
    targetLocation,
    distance,
    specialities,
    pos,
    tiers,
    networks,
    facility,
    provider,
    sort,
    limit,
    transformedNetworkTier,
  } = useSelector((state: RootState) => state.priceTransparency);
  const userInfo = useUserInfo();
  const costEstFilterParams: ICostEstFilterParams = {
    key,
    procedure,
    targetLocation:
      targetLocation?.lat && targetLocation?.lng
        ? targetLocation
        : {
            lat: userInfo.lat,
            lng: userInfo.lng,
            description: "",
            place_id: "",
            reference: "",
          },
    distance,
    pos,
    tiers,
    networks,
    facility,
    provider,
    specialities,
    sort,
    limit,
    transformedNetworkTier,
  };

  return costEstFilterParams;
};

export default useCostEstFilter;
